export default "__VITE_ASSET__BQ3V0$1P__"